if(document.getElementsByClassName('animation-container').length > 0) {
	var mouseX = 0;
	var mouseY = 0;

	function createRectangle(event, numRectangles) {
		for (var i = 0; i < numRectangles; i++) {
			const rectangle = document.createElement('div');
			rectangle.classList.add('rectangle');
			rectangle.style.left = event.clientX - 10 + 'px';
			rectangle.style.top = event.clientY - 5 + 'px';
			rectangle.style.backgroundColor = getRandomColor();
			rectangle.style.setProperty('--move-x', getRandomMovement() + 'px');
			rectangle.style.setProperty('--move-y', getRandomMovement() + 'px');
			rectangle.style.setProperty('--rotate', getRandomRotation() + '');
			var duration = Math.floor(Math.random() * 6 + 10) * 1000; // Random duration between 10 and 15 seconds
			rectangle.style.animationDuration = duration + 'ms';
			rectangle.style.transition = 'opacity ' + (duration * 0.6) + 'ms'; // Adjust the opacity transition duration
			document.getElementsByClassName('animation-container')[0].appendChild(rectangle);

			setTimeout(function() {
				rectangle.remove();
			}, duration); // Delay the opacity decrease
		}
	}

	function spawnRectangleOnMousePosition(event) {
		mouseX = event.clientX;
		mouseY = event.clientY;
	}
	document.addEventListener('mousemove', spawnRectangleOnMousePosition);

	document.addEventListener('click', function(event) {
		createRectangle(event, Math.floor(Math.random() * 3) + 10); // Random number between 4 and 6
	});

	setInterval(function() {
		createRectangle({ clientX: mouseX, clientY: mouseY }, Math.floor(Math.random() * 3) + 4); // Random number between 4 and 6
	}, 2000); // Spawn rectangles at an interval of 2 seconds

	function getRandomColor() {
		var color = "hsl(" + Math.random() * 360 + ", 100%,"+ (Math.floor(Math.random() * 10) + 55)+"%)";
		return color;
	}

	function getRandomMovement() {
		var movement = (Math.floor(Math.random() * 201) - 100) * 4; // Random number between -200 and 200 (doubled speed)
		return movement;
	}

	function getRandomRotation() {
		var rotation = Math.random() * 2 - 1; // Random number between -1 and 1
		return rotation;
	}
}
